
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ConfirmadorAjusteCargo from './ConfirmadorAjusteCargo.jsx';
import * as actions from '../actions/Actions.js';

const mapStateToProps = (state) => {
    return {
        data: state.ConfirmadorAjusteCargo,
        tarjetas: state.tarjetas,
    }
}

const mapDispatchToProps = (dispatch) => { return { actions: bindActionCreators(actions, dispatch) } }

const ConfirmadorAjusteCargoContainer = connect(mapStateToProps, mapDispatchToProps)(ConfirmadorAjusteCargo);


export default ConfirmadorAjusteCargoContainer;